// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__UfFDT","buttons":"LoginPage_buttons__64a-6","error":"LoginPage_error__EGaA6"};